import React from 'react';

import { useTranslation } from 'react-i18next';

import { Inner, Text, Wrapper } from './styles';

interface Props {
    text?: string;
    bgColor?: string;
}

export const PrivateBadge = ({ text, bgColor }: Props) => {
    const { t } = useTranslation(['groups']);
    return (
        <Wrapper>
            <Inner $bgColor={bgColor}>
                <Text>{text || t('groups_private_pod')}</Text>
            </Inner>
        </Wrapper>
    );
};
